import { Lead } from 'models/Lead';
import { User } from 'models/User';

export const PROPERTY_LIST_KEYS: Array<
  keyof Pick<Lead, 'email' | 'contactNumber'>
> = ['email', 'contactNumber'];

export const REQUESTED_PRIVATE_VIEWER_COPY_AND_KEY: Partial<
  Record<keyof Lead, string>
> = {
  company: 'company',
  howDiscoverListing: 'howTheyFoundPrivateListing',
  natureOfInterest: 'natureOfInterest',
};

export const SEARCH_PREFERENCES_COPY_AND_KEY: Partial<
  Record<keyof User, string>
> = {
  budgetMinPrice: 'budgetMin',
  budgetMaxPrice: 'budgetMax',
  preferredLocations: 'location(s)',
  preferredIndustryIncludeMode: 'industriesToInclude',
  preferredIndustryExcludeMode: 'industriesToExclude',
};

export const IS_VERIFIED_PROP_LIST: Record<
  typeof PROPERTY_LIST_KEYS[number],
  keyof User
> = {
  email: 'hasVerifiedEmail',
  contactNumber: 'hasVerifiedContactNumber',
};
